export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.674 4.696l-.001.001 15.71 2.243c.753.108 1.34.611 1.565 1.269a1.79 1.79 0 01-.583 1.986c-.873.714-1.924 1.384-3.057 1.973-.68 2.334-2.008 4.27-3.987 5.635C13.23 19.246 10.486 20 7.177 20H1v-2h6.177c3.013 0 5.33-.686 7.008-1.844a7.865 7.865 0 002.562-2.927c-1.936.606-4.044.877-5.95.765-2.558-.15-5.191-1.028-6.17-3.223a6.649 6.649 0 01-.411-4.273L.85 5.988l.298-1.976 4.525.684zm.534 2.097c-.2.738-.337 1.855.246 3.163.492 1.104 2.058 1.9 4.461 2.042 2.315.136 5.003-.378 7.102-1.415a17.05 17.05 0 002.788-1.705L6.208 6.793z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};